// extracted by mini-css-extract-plugin
export default {"qna":"Qna_qna__qgnxy","icon":"Qna_icon__Gg+Uy","text":"Qna_text__Gv0lC"};